import { Box, Button, Grid, MenuItem, TextField, Typography, Autocomplete, Backdrop, CircularProgress, FormControl, FormControlLabel, RadioGroup, Radio } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Select from '@mui/material/Select';
import { useFormik } from 'formik';
import * as Yup from "yup";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { cfpBaseUrl } from '../../../network/urls';
import "../../GeneralServices/NewConnection/NewConnectionForm.scss";
import { documentExtensions, portalName } from '../../../utils/PortalName';
//jspdf
import { jsPDF } from "jspdf";
import "jspdf-autotable";
//jsbarcode
import JsBarcode from "jsbarcode";
import FESCOLOGO from "../../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../../images/DISCO Logos/HAZECO.jpg";
import SUNDARLOGO from "../../../images/discologos/sundar-logo.png";

import pitcLogo from '../../../images/pitc.png';
import MEPCOWaterMark from '../../../images/DiscosWater/mepcco-watermark.png';
import LESCOWaterMark from '../../../images/DiscosWater/lescowatermark.png';
import IESCOWaterMark from '../../../images/DiscosWater/iescowatermark.png';
import FESCOWaterMark from '../../../images/DiscosWater/fesco-watermark.png';
import GEPCOWaterMark from '../../../images/DiscosWater/gepco-watermark.png';
import HAZECOWaterMark from '../../../images/DiscosWater/hazeco-watermark.png';
import HESCOWaterMark from '../../../images/DiscosWater/hesco-watermark.png';
import TESCOWaterMark from '../../../images/DiscosWater/tesco-watermark.png';
import SEPCOWaterMark from '../../../images/DiscosWater/sepco-watermark.png';
import PESCOWaterMark from '../../../images/DiscosWater/pesco-watermark.png';
import QESCOWaterMark from '../../../images/DiscosWater/qesco-watermark.png';
import { companyShortName, numberFormatting, subdivisionName, handleFileUpload, subDivAPI, formatBillMonth, dBillAPI, calculateInstallments, getRelevantCFCCode, getPermissions, getPhase, getMeterType, calculateLpsForApi, getBusinessDaysPastDue } from '../../../services/Functions';
import Error from '../../../components/error/error';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DoneIcon from '@mui/icons-material/Done';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import StepProgressBar from '../../../components/StepProgressBarForm/StepProgressBar';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CustomerInformationCard from '../../../components/CustomerInformationCard/CustomerInformationCard';
import CheckPermissions from '../../../authorization/authorization';

// Helper function to compare current date with due date
const compareDates = (currentDateTimeStr, dueDateStr) => {
  const currentDate = new Date(currentDateTimeStr);
  const dueDate = new Date(dueDateStr);
  currentDate.setHours(0, 0, 0, 0);
  dueDate.setHours(0, 0, 0, 0);

  if (currentDate < dueDate) {
    return 'less';
  } else if (currentDate > dueDate) {
    return 'greater';
  } else {
    return 'equal';
  }
};

const InstallmentsForm = () => {
  const initialValues = {
    // Classification group Initial Values
    iv_consumer_id: '',
    iv_reference_number: '',
    iv_circle: '',
    iv_division: '',
    iv_sub_divison: '',
    iv_address: '',
    // Installment Details field
    iv_bill_month: '',
    iv_current_bill: '',
    iv_arrears: '',
    iv_lps: '',
    iv_bill_adj: '',
    iv_prev_installment: '',
    iv_outstanding: '',
    iv_total_fpa: '',
    iv_total_amount: '',
    iv_grand_total: '',
    iv_current_bill_due_date: '',
    iv_no_of_months: 0,
    // Applicant Details group Initial Values
    iv_applicant_name: '',
    iv_father_name: '',
    iv_det_month: '',
    iv_det_amount: '',
    iv_applicant_cnic: '',
    iv_applicant_phone_no: '',
    iv_applicant_email: '',
    // Required Documents Initial Values
    iv_applicant_cnic_document: null,
    iv_connection_type: '',
    iv_tariff_description: '',
    iv_tariff_code: '',
    iv_cc_code: '',
    iv_down_payment: 0,
    iv_ed_code: null,
    iv_meter_type: '',
    iv_phase: ''
  }
  useEffect(() => {
  }, [])
  // Classification Group States
  const [referenceNumber, setReferenceNumber] = useState('');
  const [subDivision, setSubDivision] = React.useState({ code: null, name: '' });
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [applicationId, setApplicationId] = useState();
  const [installmentsPopUp, setInstallmentsPopUp] = useState(false);
  const navigate = useNavigate();
  const [searchBy, setSearchBy] = useState('referenceNo');
  // Documents states
  const [applicantCnicDocument, setApplicantCnicDocument] = useState('');
  const [applicantCnicDocumentError, setApplicantCnicDocumentError] = useState('');
  // Thumbnail states
  const [applicantCnicDocumentThumbnail, setApplicantCnicDocumentThumbnail] = useState(null);
  // States for hiding conditional fields
  const [hierarchyList, setHierarchyList] = useState([]);
  const [circleList, setCircleList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [subDivisionList, setSubDivisionList] = useState([]);
  const [defaultCircle, setDefaultCircle] = useState();
  const [defaultDivision, setDefaultDivision] = useState();
  const [customerId, setCustomerId] = useState('');
  const [error, setError] = useState();
  const [unpaidDebt, setUnpaidDebt] = useState(null);
  const [billMonth, setBillMonth] = useState('');
  const [tariff, setTariff] = useState('');
  const [ccCode, setCcCode] = useState('');
  const [installmentsArray, setInstallmentsArray] = useState([])
  const [minDownPayment, setMinDownPayment] = useState(0);
  const [maxBillAmount, setMaxBillAmount] = useState(0);
  const [installmentsAlreadyCheck, setInstallmentsAlreadyCheck] = useState(false)
  const [installmentsProvisions, setInstallmentProvisions] = useState();
  const [isGovtDept, setIsGovtDept] = useState(false);
  const [isPDisc, setIsPDisc] = useState(false);
  const [isDetectionBill, setIsDetectionBill] = useState(false)
  const [isDueDatePassed, setIsDueDatePassed] = useState(false)

  const [netBill, setNetBill] = useState('');
  const [payment13, setPayment13] = useState('');
  const [gbHistAss13, setGbHistAss13] = useState('');
  const [govtDepCode, setGovtDepCode] = useState('');
  const [basicInfoData, setBaicInfoData] = useState({});

  const { token, code: userCode, userId, cfcLevelId, csc, permissions, currentDateTime } = useSelector((state) => state.auth)
  let subDivList = JSON.parse(window.localStorage.getItem("subDivisions"));
  // const { data: installmentProvisions } = useSelector((state) => state.provisions)
  // const [intsallprovApi, setIntsallprovApi] = useState([]);
  let subDivisionsArray = JSON.parse(
    window.localStorage.getItem("subDivisions")
  );
  let userCompany = userCode.slice(0, 2);
  const getWaterMarkLogo = (code) => {
    switch (code) {
      case '11':
        return LESCOWaterMark
      case '12':
        return GEPCOWaterMark
      case '13':
        return FESCOWaterMark
      case '14':
        return IESCOWaterMark
      case '15':
        return MEPCOWaterMark
      case '26':
        return PESCOWaterMark
      case '27':
        return HAZECOWaterMark
      case '37':
        return HESCOWaterMark
      case '38':
        return SEPCOWaterMark
      case '48':
        return QESCOWaterMark
      case '59':
        return TESCOWaterMark
      default:
        return MEPCOWaterMark
    }
  }
  const getLogo = (code) => {
    switch (code) {
      case '10':
        return pitcLogo
      case '11':
        return LESCOLOGO
      case '12':
        return GEPCOLOGO
      case '13':
        return FESCOLOGO
      case '14':
        return IESCOLOGO
      case '15':
        return MEPCOLOGO
      case '26':
        return PESCOLOGO
      case '27':
        return HAZECOLOGO
      case '37':
        return HESCOLOGO
      case '38':
        return SEPCOLOGO
      case '48':
        return QESCOLOGO
      case '59':
        return TESCOLOGO
      case '91':
        return SUNDARLOGO
      default:
        return MEPCOLOGO
    }
  }
  const errorCloses = () => {
    setError('')
  }
  useEffect(() => {
    setViewBackdrop(true);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow"
    };

    fetch(cfpBaseUrl + "actionables/getRanges", requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (Array.isArray(data)) {
          const filteredData = data.filter(item => item.id === "8");
          setInstallmentProvisions(filteredData);
        } else {
          console.warn("Unexpected response structure:", data);
        }
      })
      .catch((error) => {
      })
      .finally(() => {
        setViewBackdrop(false);
      });
  }, [token]);


  const SearchBy = (event) => {
    values.iv_search_by = event.target.value;
    setSearchBy(event.target.value);
    setDefaultCircle('')
    setDefaultDivision('')
    setError('')
    setSubDivision('')
    setGovtDepCode('');
    setIsGovtDept(false)
    setIsPDisc(false)
    setIsDueDatePassed(false)
    setGbHistAss13('')
    setPayment13('')
    setNetBill('')
    resetForm()
    values.iv_address = ''
    values.iv_circle = ''
    values.iv_division = ''
    values.iv_sub_divison = ''
    values.iv_consumer_id = ''
    values.iv_reference_number = ''
    values.iv_applicant_name = ''
    values.iv_father_name = ''
    values.iv_det_month = ''
    values.iv_det_amount = ''
    values.iv_connection_type = ''
    values.iv_tariff_code = ''
    values.iv_meter_type = ''
    values.iv_phase = ''
    values.iv_tariff_description = ''
    values.iv_applicant_cnic = ''
    values.iv_applicant_phone_no = ''
    values.iv_applicant_email = ''
    values.iv_current_bill = ''
    values.iv_total_amount = ''
    values.iv_grand_total = ''
    values.iv_arrears = ''
    values.iv_lps = ''
    values.iv_bill_adj = ''
    values.iv_prev_installment = ''
    values.iv_outstanding = ''
    values.iv_total_fpa = ''

    setMaxBillAmount(null);
    values.iv_current_bill_due_date = ''
    values.iv_no_of_months = 0
    values.iv_applicant_cnic_document = null
    setApplicantCnicDocument()
    setApplicantCnicDocumentThumbnail()
    setReferenceNumber('');
    setBillMonth('')
    setTariff('')
    setIsDetectionBill(false)
    setCcCode('')
  };

  const referedToCFCLevelId = (totalBillAmount, noOfInstallments) => {
    if (installmentsProvisions) {
      let referedToCFCLevelId = 0;
      let instProvAccToNos = installmentsProvisions.filter((item) => item.noOfActions == noOfInstallments)
      let instProvAccToBillAmount = instProvAccToNos.find((item) => (item.amountFrom <= totalBillAmount) && (item.amountTo >= totalBillAmount))
      if (instProvAccToBillAmount.cfcLevelId) {
        referedToCFCLevelId = instProvAccToBillAmount.cfcLevelId
      }
      return referedToCFCLevelId
    }
  }

  const getFinalCFCLevelId = (initialReferedToCFCId, loggedInUserCFCId) => {
    if (initialReferedToCFCId && loggedInUserCFCId) {
      if (initialReferedToCFCId == loggedInUserCFCId) {
        return initialReferedToCFCId
      } else if (loggedInUserCFCId > initialReferedToCFCId) {
        return initialReferedToCFCId
      } else if (loggedInUserCFCId < initialReferedToCFCId) {
        return loggedInUserCFCId
      }
    }
  }

  const getOfficeCode = (referedToCFCLevelId, referenceNo) => {
    let officeCode = ''
    if (referedToCFCLevelId == 2) {
      officeCode = referenceNo.slice(2, 4)
    } else if (referedToCFCLevelId == 3) {
      officeCode = referenceNo.slice(2, 5)
    } else if (referedToCFCLevelId == 4) {
      officeCode = referenceNo.slice(2, 6)
    } else if (referedToCFCLevelId == 5) {
      officeCode = referenceNo.slice(2, 7)
    }
    return officeCode
  }

  const getRelevantCFCId = async (totalBill, noOfInst, referenceNo) => {
    if (installmentsProvisions) {
      let referedToCFCId = ''
      let initialReferedToCFCId = referedToCFCLevelId(totalBill, noOfInst)
      if (!(initialReferedToCFCId == parseInt(cfcLevelId))) {
        let referedToCFCLevelId = getFinalCFCLevelId(initialReferedToCFCId, parseInt(cfcLevelId))
        let officeCode = getOfficeCode(referedToCFCLevelId, referenceNo)
        referedToCFCId = await getRelevantCFCCode(token, officeCode, referedToCFCLevelId)
      } else {
        referedToCFCId = userCode
      }
      return referedToCFCId
    }
  }

  // Formik form submission and new connection API calling
  const { values, errors, touched, handleBlur, handleChange, handleSubmit, resetForm,submitCount  } = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_reference_number: Yup.string().when('iv_search_by', {
        is: () => searchBy === 'referenceNo',
        then: Yup.string().min(14, 'Reference No. must be 14 digits.').max(14, 'Reference No. must be 14 digits.').required("Enter reference number."),
        otherwise: Yup.string().optional()
      }),
      iv_consumer_id: Yup.string().when('iv_search_by', {
        is: () => searchBy === 'consumerId',
        then: Yup.string().min(10, 'Customer ID. must be 10 digits.').max(10, 'Customer ID. must be 10 digits.').required("Enter consumer Id."),
        otherwise: Yup.string().optional()
      }),
      iv_circle: Yup.mixed().required("Please select a circle."),
      iv_division: Yup.mixed().required("Please select a division."),
      iv_sub_divison: Yup.mixed().required("Please select a sub division."),
      iv_current_bill: Yup.mixed().required("Can't apply! No current bill."),
      iv_total_amount: Yup.mixed().required("Can't apply! No total amount."),
      iv_grand_total: Yup.mixed().required("Can't apply! No Grand total amount."),
      iv_arrears: Yup.mixed().optional(""),
      iv_lps: Yup.mixed().optional(""),
      iv_bill_adj: Yup.mixed().optional(""),
      iv_outstanding: Yup.mixed().optional(""),
      iv_prev_installment: Yup.mixed().optional(""),
      iv_current_bill_due_date: Yup.mixed().required("Can't apply! No current bill due date."),
      iv_no_of_months: Yup.mixed().required("Please select no of months for installments."),
iv_applicant_phone_no: Yup.string()
  .max(11, "Please enter 11 digit phone number.")
  .min(11, "Please enter 11 digit phone number.")
  .required("Please enter valid mobile number.")
  .matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone number as 03001234567"),
        iv_applicant_cnic_document: Yup.mixed().optional(),
      // iv_down_payment: Yup.number().required('Enter Down Payment.').max(maxBillAmount, `Down Payment can't be more than Bill amount.`),
      iv_down_payment: Yup.number().required('Enter Down Payment.').min(1, `Down Payment must be greater than 0.`),

    }),
    onSubmit: async (values, { resetForm }) => {
      console.log('Submitting form with values:', values,);
      const parseAmount = (amount) =>
        Number(String(amount ?? "").replace(/,/g, "").trim()) || 0;

      const netBillNum = parseAmount(netBill);
      const payment13Num = parseAmount(payment13);
      const gbHistAss13Num = parseAmount(gbHistAss13);
      const totalAmountNum = parseAmount(values.iv_total_amount);
      const detNetBillNum = parseAmount(detInfo?.DETNETBILL);

      if (gbHistAss13Num > 0 && gbHistAss13Num === payment13Num) {
        setError("Bill already paid.");
        return;
      }
      else if (netBillNum < 0) {
        setError("Request cannot be entertained.");
        return;
      }
      else if (netBillNum > 0 && payment13Num >= netBillNum) {
        setError("Bill already paid.");
        return;
      }
      if (detNetBillNum > 0 && detNetBillNum === totalAmountNum) {
        setError("Installment not allowed for Detection Bill.");
        return;
      }
      else {
        setViewBackdrop(true)

        const dateComparison = compareDates(currentDateTime, values.iv_current_bill_due_date);
        let totalBill =
          (values.iv_current_bill
            ? parseInt(values.iv_current_bill.replace(/,/g, ''))
            : 0) +
          (values.iv_arrears
            ? parseInt(values.iv_arrears.replace(/,/g, ''))
            : 0) +
          (dateComparison === 'greater' && values.iv_lps
            ? parseInt(values.iv_lps.replace(/,/g, ''))
            : 0) +
          (values.iv_bill_adj
            ? parseInt(values.iv_bill_adj.replace(/,/g, ''))
            : 0) +
          (values.iv_prev_installment
            ? parseInt(values.iv_prev_installment.replace(/,/g, ''))
            : 0) +
          (values.iv_outstanding
            ? parseInt(values.iv_outstanding.replace(/,/g, ''))
            : 0);

        let referedToCFCId = await getRelevantCFCId(totalBill, values.iv_no_of_months, referenceNumber)

        console.log('referedToCFCId', referedToCFCId);

        // Calculate LPS based on days past due date:
        // <= 0 days (not passed or equal): No LPS
        // 1-3 days past due: Half LPS
        // > 3 days past due: Full LPS
        const lpsForApi = calculateLpsForApi(values.iv_lps, currentDateTime, values.iv_current_bill_due_date);

        console.log('lpsForApi', lpsForApi);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          "refNo": referenceNumber,
          "applicantCNIC": values.iv_applicant_cnic,
          "customerId": customerId,
          "billMonthAmount": values.iv_current_bill ? values.iv_current_bill.replace(/,/g, '') : 0,
          "billMonthDueDate": values.iv_current_bill_due_date,
          "noOfMonthsForInstallment": values.iv_no_of_months,
          "applicantCNICImage": applicantCnicDocumentThumbnail,
          "applicantPhone": values.iv_applicant_phone_no,
          "applicantEmail": values.iv_applicant_email,
          "applicantName": values.iv_applicant_name,
          "billMonth": values.iv_bill_month,
          "tariffCode": values.iv_tariff_code,
          "ccCode": values.iv_cc_code,
          "address": values.iv_address,
          "connectionType": values.iv_connection_type,
          "tariffDesc": values.iv_tariff_description,
          "cfcId": csc,
          "referedToCFCId": referedToCFCId,
          "totalFPA": values.iv_total_fpa ? values.iv_total_fpa.replace(/,/g, '') : 0,
          "outstandingAmount": values.iv_outstanding ? values.iv_outstanding.replace(/,/g, '') : 0,
          "detectBillMonth": values.iv_det_month ? values.iv_det_month.replace(/,/g, '') : 0,
          "detectBillAmount": values.iv_det_amount ? values.iv_det_amount.replace(/,/g, '') : 0,
          "currentMonthNetBill": (values.iv_total_amount ? parseInt(values.iv_total_amount.replace(/,/g, '')) : 0) + lpsForApi,
          "submittedThrough": portalName,
          "arrears": values.iv_arrears ? values.iv_arrears.replace(/,/g, '') : 0,
          "lps": lpsForApi,
          "billAdjustment": values.iv_bill_adj ? values.iv_bill_adj.replace(/,/g, '') : 0,
          "prevInstallment": values.iv_prev_installment ? values.iv_prev_installment.replace(/,/g, '') : 0,
          "downPayment": values.iv_down_payment ? values.iv_down_payment : 0
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow"
        };

        fetch(cfpBaseUrl + "installments/registerbillInstallment", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.status === '200') {
              setViewBackdrop(false)
              const applicationID = result.billInstallmentRequestId
              setApplicationId(result.billInstallmentRequestId)
              setInstallmentsPopUp(true)
              printApplicationReceipt(values, applicationID, userId, referenceNumber);
              resetForm()
              setDefaultCircle()
              setDefaultDivision()
              setSubDivision()
            }
            else {
              setViewBackdrop(false)
              setError(result.message)
            }
          })
          .catch((error) => {
            setViewBackdrop(false)
            console.error(error)
          });
      }

     }
  })

  useEffect(() => {
    const loadSubDivs = async () => {
      if (userCompany && cfpBaseUrl && token) {
        setViewBackdrop(true)
        const lists = await subDivAPI(subDivList)
        setHierarchyList(lists.hierarchyList)
        setCircleList(lists.circleList)
        setDivisionList(lists.divisionList)
        setSubDivisionList(lists.subDivisionList)
        setViewBackdrop(false)
      }
    }
    loadSubDivs()
  }, []);

  // useEffect(() => {
  //   let provis = intsallprovApi.filter((item) => item.id == 8)
  //   setInstallmentProvisions(provis)
  // }, [intsallprovApi])

  useEffect(() => {
    if (!hierarchyList || !defaultCircle) return;

    const uniqueDivisions = hierarchyList
      .filter(division => division.circleCode === defaultCircle.code)
      .reduce((uniqueDivisions, division) => {
        const existingDivision = uniqueDivisions.find(d => d.code === division.divisionCode);
        if (!existingDivision) {
          uniqueDivisions.push({
            code: division.divisionCode,
            name: division.divisionName,
          });
        }
        return uniqueDivisions;
      }, []);

    const sortedDivisionArray = uniqueDivisions.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true }));

    setDivisionList(sortedDivisionArray);
  }, [defaultCircle, hierarchyList]);

  useEffect(() => {
    if (!defaultDivision || !hierarchyList) return;

    const uniqueSubDivisions = hierarchyList
      .filter(subDivision => subDivision.divisionCode === defaultDivision.code)
      .reduce((uniqueSubDivisions, subDivision) => {
        const existingSubDivision = uniqueSubDivisions.find(s => s.code === subDivision.subDivisionCode);
        if (!existingSubDivision) {
          uniqueSubDivisions.push({
            code: subDivision.subDivisionCode,
            name: subDivision.subDivisionName,
          });
        }
        return uniqueSubDivisions;
      }, []);

    const sortedSubDivisionArray = uniqueSubDivisions.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true }));

    setSubDivisionList(sortedSubDivisionArray);
  }, [defaultDivision, hierarchyList]);

  // Calling Billing API to fetch near by details
  useEffect(() => {
    if (referenceNumber && referenceNumber.length === 14) {
      let enteredReferenceNo = referenceNumber;
      let circleCode = enteredReferenceNo.slice(2, 5);
      let circleObject = circleList.find(item => item.code === parseInt(circleCode));

      if (!circleObject) {
        // Handle circle not found
        console.error(`Circle not found with code: ${circleCode}. Contact Admin!`);
        setError(`Circle not found with code: ${circleCode}`);
        return;
      }

      setDefaultCircle(circleObject);
      values.iv_circle = circleObject.code;

      let divisionCode = enteredReferenceNo.slice(2, 6);
      let subDivisionCode = enteredReferenceNo.slice(2, 7);

      let uniqueDivisions = [];

      for (let i = 0; i < hierarchyList.length; i++) {
        const division = hierarchyList[i];
        if (division.circleCode === parseInt(circleCode)) {
          const existingDivision = uniqueDivisions.find(c => c.code === division.divisionCode);
          if (!existingDivision) {
            uniqueDivisions.push({
              code: division.divisionCode,
              name: division.divisionName,
            });
          }
        }
      }

      let sortedDivisionArray = uniqueDivisions.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
      );
      let defDivision = sortedDivisionArray.find(item => item.code === parseInt(divisionCode));

      if (!defDivision) {
        // Handle division not found
        console.error(`Division not found with code: ${divisionCode}`);
        setError(`Division not found with code: ${divisionCode}. Contact Admin!`);
        return;
      }

      setDefaultDivision(defDivision);
      values.iv_division = defDivision.code;
      setDivisionList(sortedDivisionArray);

      let uniqueSubDivisions = [];

      for (let i = 0; i < hierarchyList.length; i++) {
        const subDivision = hierarchyList[i];
        if (subDivision.divisionCode === parseInt(divisionCode)) {
          const existingSubDivision = uniqueSubDivisions.find(c => c.code === subDivision.subDivisionCode);
          if (!existingSubDivision) {
            uniqueSubDivisions.push({
              code: subDivision.subDivisionCode,
              name: subDivision.subDivisionName,
            });
          }
        }
      }

      let sortedSubDivisionArray = uniqueSubDivisions.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
      );

      let subDivisionObject = sortedSubDivisionArray.find(item => item.code === parseInt(subDivisionCode));
      if (!subDivisionObject) {
        // Handle subdivision not found
        console.error(`Subdivision not found with code: ${subDivisionCode}`);
        setError(`Subdivision not found with code: ${subDivisionCode}. Contact Admin!`);
        return;
      }

      values.iv_sub_divison = subDivisionObject.code;
      setSubDivision(subDivisionObject);
      setSubDivisionList(sortedSubDivisionArray);
    }
  }, [referenceNumber]);


  useEffect(() => {
    if (values.iv_consumer_id.length === 10) {
      referenceApi();
    } else {
      setDefaultCircle('')
      setDefaultDivision('')
      setUnpaidDebt(null);
      setError('')
      setInstallmentsAlreadyCheck(false)
      setGovtDepCode('');
      setSubDivision('')
      setIsGovtDept(false)
      setIsPDisc(false)
      setIsDueDatePassed(false)
      setGbHistAss13('')
      setPayment13('')
      setNetBill('')
      setIsDetectionBill(false)
      values.iv_address = ''
      values.iv_circle = ''
      values.iv_division = ''
      values.iv_sub_divison = ''
      values.iv_reference_number = ''
      values.iv_applicant_name = ''
      values.iv_father_name = ''
      values.iv_det_month = ''
      values.iv_det_amount = ''
      values.iv_applicant_cnic = ''
      values.iv_applicant_phone_no = ''
      values.iv_applicant_email = ''
      values.iv_current_bill = ''
      values.iv_total_amount = ''
      values.iv_grand_total = ''
      values.iv_arrears = ''
      values.iv_lps = ''
      values.iv_bill_adj = ''
      values.iv_prev_installment = ''
      values.iv_outstanding = ''
      values.iv_total_fpa = ''
      setMaxBillAmount(null)
      values.iv_current_bill_due_date = ''
      values.iv_no_of_months = 0
      values.iv_applicant_cnic_document = null
      values.iv_connection_type = ''
      values.iv_tariff_description = ''
      values.iv_tariff_code = ''
      values.iv_bill_month = ''
      values.iv_meter_type = ''
      values.iv_phase = ''
      values.iv_cc_code = ''
      setApplicantCnicDocument()
      setApplicantCnicDocumentThumbnail()
      setReferenceNumber('')
      values.iv_total_fpa = ''
      values.iv_outstanding = ''
      values.iv_det_amount = ''
      values.iv_det_month = ''
      values.iv_grand_total = ''
      values.iv_lps = ''
      values.iv_total_amount = ''
      values.iv_prev_installment = ''
      values.iv_prev_installment = ''
      values.iv_bill_adj = ''
      values.iv_current_bill = ''
      values.iv_arrears = ''
      values.iv_current_bill_due_date = ''
      values.iv_bill_month = ''
      setInstallmentsArray([])
    }
  }, [values.iv_consumer_id])

  useEffect(() => {
    if (values.iv_reference_number.length === 14) {
      referenceApi();
    } else {
      setDefaultCircle('')
      setDefaultDivision('')
      setInstallmentsAlreadyCheck(false)
      setUnpaidDebt(null);
      setError('')
      setGovtDepCode('');
      setSubDivision('')
      setIsGovtDept(false)
      setIsPDisc(false)
      setIsDueDatePassed(false)
      setGbHistAss13('')
      setPayment13('')
      setNetBill('')
      setIsDetectionBill(false)
      values.iv_address = ''
      values.iv_circle = ''
      values.iv_division = ''
      values.iv_sub_divison = ''
      values.iv_consumer_id = ''
      values.iv_applicant_name = ''
      values.iv_father_name = ''
      values.iv_det_month = ''
      values.iv_det_amount = ''
      values.iv_applicant_cnic = ''
      values.iv_applicant_phone_no = ''
      values.iv_applicant_email = ''
      values.iv_current_bill = ''
      values.iv_total_amount = ''
      values.iv_grand_total = ''
      values.iv_arrears = ''
      values.iv_lps = ''
      values.iv_bill_adj = ''
      values.iv_prev_installment = ''
      setMaxBillAmount(null)
      values.iv_current_bill_due_date = ''
      values.iv_no_of_months = 0
      values.iv_applicant_cnic_document = null
      values.iv_connection_type = ''
      values.iv_tariff_description = ''
      values.iv_tariff_code = ''
      values.iv_meter_type = ''
      values.iv_phase = ''
      values.iv_bill_month = ''
      values.iv_cc_code = ''
      setApplicantCnicDocument()
      setApplicantCnicDocumentThumbnail()
      setReferenceNumber('')
      values.iv_total_fpa = ''
      values.iv_outstanding = ''
      values.iv_det_amount = ''
      values.iv_det_month = ''
      values.iv_grand_total = ''
      values.iv_lps = ''
      values.iv_total_amount = ''
      values.iv_prev_installment = ''
      values.iv_prev_installment = ''
      values.iv_bill_adj = ''
      values.iv_current_bill = ''
      values.iv_arrears = ''
      values.iv_current_bill_due_date = ''
      values.iv_bill_month = ''
      setInstallmentsArray([])
    }
  }, [values.iv_reference_number])

  useEffect(() => {
    if (isGovtDept) {
      values.iv_no_of_months = 1
    } else {
      values.iv_no_of_months = 0
    }
  }, [isGovtDept])


  const [detInfo, setDetInfo] = useState({});
  // Function to fetch sub division and near by name and address through API 
  const referenceApi = async () => {
    if (searchBy === 'consumerId') {
      if (!values.iv_consumer_id) return;
      setViewBackdrop(true)
      let apiResponse = await dBillAPI(token, values.iv_consumer_id)
      const basicInfo = apiResponse.basicInfo
      const histInfo = apiResponse.histInfo
      if (apiResponse.status || basicInfo) {
        const basicInfo = apiResponse.basicInfo
        setBaicInfoData(basicInfo)
        const detInfo = apiResponse.detInfo
        setDetInfo(detInfo);
        values.iv_address = basicInfo.consumerAddress1 + basicInfo.consumerAddress2
        values.iv_ed_code = basicInfo.edCd
        // if (basicInfo.edCd == '5' || basicInfo.edCd == '6') {
        //   setIsGovtDept(true)
        //  setGovtDepCode(basicInfo.edCd);
        // } else {
        //   setIsGovtDept(false)
        //   setGovtDepCode('');
        // }
        // setIsGovtDept(false)
        // setGovtDepCode('');
        if (basicInfo.isDetBill == true) {
          setIsDetectionBill(basicInfo.isDetBill)
          values.iv_det_month = detInfo.DETBILMONTH ? detInfo.DETBILMONTH : ''
          values.iv_det_amount = numberFormatting(detInfo.DETNETBILL ? detInfo.DETNETBILL : '0')
        }

        values.iv_father_name = basicInfo.consumerFName
        values.iv_current_bill = numberFormatting(basicInfo.currAmntDue)
        values.iv_arrears = numberFormatting(basicInfo.arrear ? basicInfo.arrear : 0)
        values.iv_lps = numberFormatting(basicInfo.LatePaymentSurcharge ? basicInfo.LatePaymentSurcharge : 0)
        values.iv_bill_adj = numberFormatting(basicInfo.billAdj ? basicInfo.billAdj : 0)
        values.iv_prev_installment = numberFormatting(basicInfo.installment ? basicInfo.installment : 0)
        values.iv_total_fpa = numberFormatting(basicInfo.totalFpa ? basicInfo.totalFpa.replace(/,/g, '') : 0)
        setMaxBillAmount(parseInt(basicInfo.netBill ? basicInfo.netBill.replace(/,/g, '') : 0) + parseInt(basicInfo.LatePaymentSurcharge ? basicInfo.LatePaymentSurcharge.replace(/,/g, '') : 0))
        values.iv_total_amount = numberFormatting(parseInt(basicInfo.netBill ? basicInfo.netBill.replace(/,/g, '') : 0) + parseInt(basicInfo.unpaid_debt ? basicInfo.unpaid_debt.replace(/,/g, '') : 0));

        values.iv_current_bill_due_date = basicInfo.billDueDate
        const dateComparison = compareDates(currentDateTime, values.iv_current_bill_due_date);
        setIsDueDatePassed(dateComparison === 'greater');

        // Calculate LPS based on business days past due (0 if not passed, half if 1-3 days, full if >3 days)
        const calculatedLps = calculateLpsForApi(basicInfo.LatePaymentSurcharge, currentDateTime, basicInfo.billDueDate);
        values.iv_grand_total = numberFormatting(parseInt(values.iv_total_amount ? values.iv_total_amount.replace(/,/g, '') : 0) +
          calculatedLps + parseInt(values.iv_det_amount ? values.iv_det_amount.replace(/,/g, '') : 0));

        values.iv_applicant_name = basicInfo.consumerName
        values.iv_father_name = basicInfo.consumerFName
        values.iv_applicant_cnic = basicInfo.owner_cnic
        values.iv_applicant_phone_no = basicInfo.consumerContactNo
        values.iv_applicant_email = basicInfo.consumerEmail
        values.iv_connection_type = basicInfo.cons_cat
        values.iv_tariff_description = basicInfo.tariffDescription
        values.iv_tariff_code = basicInfo.tariffCode
        values.iv_bill_month = basicInfo.billMonth
        values.iv_cc_code = basicInfo.cc_code ? basicInfo.cc_code : "1501"
        values.iv_phase = getPhase(basicInfo.sactionLoad)
        values.iv_meter_type = getMeterType(basicInfo.conn_catg, basicInfo.meterType, basicInfo.phase, apiResponse.metersInfo.length)
        setUnpaidDebt(basicInfo.unpaid_debt)
        setReferenceNumber(basicInfo.refNo.replace(/ /g, "").slice(0, 14))
        setCustomerId(basicInfo.appNo)
        setNetBill(basicInfo.netBill ? basicInfo.netBill.replace(/,/g, '') : '0')

        setPayment13(histInfo.payment13 ? histInfo.payment13.replace(/,/g, '') : '0')
        setGbHistAss13(histInfo.gbHistAssment13 ? histInfo.gbHistAssment13.replace(/,/g, '') : '0')
      }
      else if (apiResponse.status == false) {
        setError('No Data Found against this Customer ID.')
        errors.iv_reference_number = 'No Data Found against this Customer ID.'
      } else {
        setError('Customer ID. not found!')
        errors.iv_consumer_id = 'Customer ID. not found!'
      }
      setViewBackdrop(false)
    }
    if (searchBy === 'referenceNo') {
      if (!values.iv_reference_number) return;
      setViewBackdrop(true)
      let apiResponse = await dBillAPI(token, values.iv_reference_number)
      if (apiResponse.status) {
        const basicInfo = apiResponse.basicInfo
        setBaicInfoData(basicInfo)
        const detInfo = apiResponse.detInfo
        const histInfo = apiResponse.histInfo
        values.iv_address = basicInfo.consumerAddress1 + basicInfo.consumerAddress2
        values.iv_ed_code = basicInfo.edCd
        // if (basicInfo.edCd == '5' || basicInfo.edCd == '6') {
        //   setIsGovtDept(true)
        //   setGovtDepCode(basicInfo.edCd);
        // } else {
        //   setIsGovtDept(false)
        //   setGovtDepCode('');
        // }
        setIsGovtDept(false)
        setGovtDepCode('');
        if (basicInfo.isDetBill == true) {
          setIsDetectionBill(basicInfo.isDetBill)
          values.iv_det_month = detInfo.DETBILMONTH ? detInfo.DETBILMONTH : ''
          values.iv_det_amount = numberFormatting(detInfo.DETNETBILL ? detInfo.DETNETBILL : '0')
        }
        values.iv_current_bill = numberFormatting(basicInfo.currAmntDue)
        values.iv_arrears = numberFormatting(basicInfo.arrear ? basicInfo.arrear : 0)

        values.iv_lps = numberFormatting(basicInfo.LatePaymentSurcharge ? basicInfo.LatePaymentSurcharge : 0)
        values.iv_bill_adj = numberFormatting(basicInfo.billAdj ? basicInfo.billAdj : 0)
        values.iv_prev_installment = numberFormatting(basicInfo.installment ? basicInfo.installment : 0)
        values.iv_outstanding = numberFormatting(basicInfo.unpaid_debt ? basicInfo.unpaid_debt.replace(/,/g, '') : 0)
        values.iv_total_fpa = numberFormatting(basicInfo.totalFpa ? basicInfo.totalFpa.replace(/,/g, '') : 0)

        values.iv_total_amount = numberFormatting(parseInt(basicInfo.netBill ? basicInfo.netBill.replace(/,/g, '') : 0) + parseInt(basicInfo.unpaid_debt ? basicInfo.unpaid_debt.replace(/,/g, '') : 0));

        setMaxBillAmount(parseInt(basicInfo.netBill ? basicInfo.netBill.replace(/,/g, '') : 0) + parseInt(basicInfo.LatePaymentSurcharge ? basicInfo.LatePaymentSurcharge.replace(/,/g, '') : 0))
        values.iv_current_bill_due_date = basicInfo.billDueDate
        const dateComparison = compareDates(currentDateTime, values.iv_current_bill_due_date);
        setIsDueDatePassed(dateComparison === 'greater');

        // Calculate LPS based on business days past due (0 if not passed, half if 1-3 days, full if >3 days)
        const calculatedLps = calculateLpsForApi(basicInfo.LatePaymentSurcharge, currentDateTime, basicInfo.billDueDate);
        values.iv_grand_total = numberFormatting(parseInt(values.iv_total_amount ? values.iv_total_amount.replace(/,/g, '') : 0) +
          calculatedLps + parseInt(values.iv_det_amount ? values.iv_det_amount.replace(/,/g, '') : 0));

        values.iv_applicant_name = basicInfo.consumerName
        values.iv_father_name = basicInfo.consumerFName
        values.iv_applicant_cnic = basicInfo.owner_cnic
        values.iv_applicant_phone_no = basicInfo.consumerContactNo
        values.iv_applicant_email = basicInfo.consumerEmail
        values.iv_connection_type = basicInfo.cons_cat
        values.iv_tariff_description = basicInfo.tariffDescription
        values.iv_tariff_code = basicInfo.tariffCode
        values.iv_bill_month = basicInfo.billMonth
        values.iv_cc_code = basicInfo.cc_code ? basicInfo.cc_code : "1501"
        values.iv_phase = getPhase(basicInfo.sactionLoad)
        values.iv_meter_type = getMeterType(basicInfo.conn_catg, basicInfo.meterType, basicInfo.phase, apiResponse.metersInfo.length)
        setUnpaidDebt(basicInfo.unpaid_debt)
        setReferenceNumber(basicInfo.refNo.replace(/ /g, "").slice(0, 14))
        setCustomerId(basicInfo.appNo)
        setNetBill(basicInfo.netBill ? basicInfo.netBill.replace(/,/g, '') : '0')
        setPayment13(histInfo.payment13 ? histInfo.payment13.replace(/,/g, '') : '0')
        setGbHistAss13(histInfo.gbHistAssment13 ? histInfo.gbHistAssment13.replace(/,/g, '') : '0')
      } else if (apiResponse.status == false) {
        const refNo = values.iv_reference_number;
        // const billUrl = `https://bill.pitc.com.pk/mepcobill/general?refno=${refNo}`;
        setError('No Data Found against this reference No.')
        errors.iv_reference_number = 'No Data Found against this reference No.'
        // window.open(billUrl, '_blank');
      } else {
        setError('Reference No.not found!')
        errors.iv_reference_number = 'Reference No. not found!'
      }
      setViewBackdrop(false)
    }
  };

  // useEffect(() => {
  //   if (unpaidDebt && unpaidDebt > 0) {
  //     setError(`Request can't be entertained because of OUTSTANDING INSTALLMENT AMOUNT of Rs. ${numberFormatting(unpaidDebt)}.`)
  //     setInstallmentsAlreadyCheck(true)
  //   }
  // }, [unpaidDebt])

  // useEffect(() => {
  //   if (isDetectionBill) {
  //     setError(`Request can't be entertained for DETECTION BILL.`)
  //   }
  // }, [isDetectionBill])

  //Function to set states of documents
  const ApplicantCnicDocument = (event) => {
    if (event.target.files) {
      const newFileName = 'copyOfApplicantCNIC.' + event.target.files[0].name.split(".").pop();
      handleFileUpload(event, handleChange, setApplicantCnicDocument, setApplicantCnicDocumentError, setApplicantCnicDocumentThumbnail, newFileName);
    }
  }

  const printApplicationReceipt = (values, applicationID, userId, referenceNo) => {
    let DiscoCode = values.iv_sub_divison.toString().slice(0, 2);
    const doc = new jsPDF({ compressPdf: true });
    // Generate the barcode image using JsBarcode
    const barcodeCanvas = document.createElement("canvas");
    JsBarcode(barcodeCanvas, applicationID);

    // Convert the barcode image to data URL
    const barcodeDataURL = barcodeCanvas.toDataURL("image/png");
    var height = 10;
    var padding = 10;
    const smallLogoCodes = ['12', '13', '11', '16', '26', '27', '48', '59'];
    var pageWidth = doc.internal.pageSize.getWidth();

    const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
    const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
    const logoHeight1 = smallLogoCodes.includes(DiscoCode) ? 30 : 20;

    // Get page width

    // Calculate X position to center the logo
    const logoX = (pageWidth - logoWidth) / 2;
    // Add the barcode image to the PDF document

    // Add the barcode image to the PDF document
    doc.addImage(barcodeDataURL, "PNG", 85, 260, 40, 20); // Adjust the position and size of the barcode image
    doc.addImage(getLogo(DiscoCode), "PNG", logoX, height, logoWidth, DiscoCode == '91' ? logoHeight1 : logoHeight); // Adjust the position and size of the logo image

    // height = height + 20;
    if (DiscoCode === '91') {
      height = height + 30;
    } else {
      height = height + 20;
    }

    var increment = 10;
    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.text(
      "Receipt of Installment Request",
      doc.internal.pageSize.getWidth() / 2,
      height,
      {
        align: "center",
      }
    );
    doc.setFontSize(12);
    increment = 20;
    height = height + increment;
    var leftMargin = 120;
    doc.text("DISCO / Company: ", padding, height);
    doc.text("Sub Division Code & Name:", padding + leftMargin, height);

    doc.setFont("helvetica", "normal");
    increment = 10;
    height = height + increment;
    leftMargin = 120;
    doc.text(
      companyShortName(values.iv_circle.toString().slice(0, 2)),
      padding,
      height
    );
    doc.text(
      values.iv_sub_divison.toString() +
      " / " +
      subdivisionName(values.iv_sub_divison, subDivisionsArray),
      // 'Sub Division Name',
      padding + leftMargin,
      height
    );

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Tracking ID: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(applicationID.toString(), padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Application Date: ", padding + leftMargin, height);
    doc.setFont("helvetica", "normal");
    leftMargin = 150;
    // Get the current date
    var currentDate = new Date();
    var formattedDate = currentDate.getDate() + ' ' +
      ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][currentDate.getMonth()] + ' ' +
      currentDate.getFullYear();
    doc.text(formattedDate, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Reference No: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(referenceNo, padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Applicant Name: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_applicant_name, padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Mobile No.: ", padding + leftMargin, height);
    leftMargin = 130;
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_applicant_phone_no, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Issued By: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(userId, padding + leftMargin, height);

    const totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      if (userCompany != '91') {
        doc.addImage(
          getWaterMarkLogo(userCompany),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight()
        );
      }

    }

    const pdfBlob = doc.output('blob');
    const pdfDataUrl = URL.createObjectURL(pdfBlob);

    window.open(pdfDataUrl, '_blank');

  };

  const handleClose = () => {
    setInstallmentsPopUp(false);
    navigate('/installments-table')
  };

  const [installmentsStatusBarArray, setInstallmentsStatusBarArray] = useState([{
    title1: 'APPLICATION',
    title2: 'DETAIL',
    status: 0
  },
  {
    title1: `APPLICANT's`,
    title2: 'CNIC',
    status: 0
  }]);

  useEffect(() => {
    if ((values.iv_consumer_id || values.iv_reference_number) &&
      // values.iv_applicant_phone_no &&
      values.iv_no_of_months
    ) {
      setInstallmentsStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[0] = {
          ...updatedArray[0],
          status: 1 // Set the status to the desired value
        };
        return updatedArray;
      })
    }
    else {
      setInstallmentsStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[0] = {
          ...updatedArray[0],
          status: 0 // Set the status to the desired value
        };
        return updatedArray;
      })
    }
  }, [values])

  useEffect(() => {
    if (applicantCnicDocument) {
      setInstallmentsStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[1] = {
          ...updatedArray[1],
          status: 1 // Set the status to the desired value
        };
        return updatedArray;
      })
    } else {
      setInstallmentsStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[1] = {
          ...updatedArray[1],
          status: 0 // Set the status to the desired value
        };
        return updatedArray;
      })
    }
  }, [applicantCnicDocument])

  const handleInputChange = async (e, index) => {
    if (index === 0) {
      handleChange(e);
    }
    const { value } = e.target; // No need for name here
    values.iv_down_payment = parseInt(value) || 0; // Safe parse

    // Use GRAND_TOTAL (full bill incl. outstanding/netbill) for remaining calc
    const grandTotal = parseInt(values.iv_grand_total.replace(/,/g, '')) || 0;
    const remainingBillAmount = Math.max(0, grandTotal - parseInt(value)); // Prevent negative
    const remainingMonths = values.iv_no_of_months || 0; // Total months excluding down payment

    // Recalculate remaining installments evenly
    let newInstallments = calculateInstallments(remainingBillAmount, remainingMonths);
    newInstallments.unshift(parseInt(value)); // Prepend edited down payment

    setInstallmentsArray(newInstallments);
  };

  useEffect(() => {
    if (values.iv_no_of_months) {
      let installments = calculateInstallments(parseInt(values.iv_grand_total.replace(/,/g, '')), values.iv_no_of_months + 1)
      setMinDownPayment(0)
      values.iv_down_payment = installments[0]
      setInstallmentsArray(installments)
    }
  }, [values.iv_no_of_months])
  useEffect(() => {
    console.log('govtDepCode', govtDepCode);
    if (govtDepCode === '5' || govtDepCode === '6') {
      setError("Please follow the SOP for government department installments.");
    } else {
      setError("");
    }
  }, [govtDepCode]);


  return (
    <>
      <Grid container className='nC'>
        <Box className='nCContainer'>
          <div className="headingBarDiv">
            <h3 className="heading">
              Bill Installments
            </h3>
          </div>
          <form className='ncform'>
            <Typography variant="h6" className="groupTitle">
              <div className="redCell">
              </div>
              <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                <span>
                  Applicant's Detail
                </span>
                <span style={{ backgroundColor: isGovtDept ? '#D81D24' : isPDisc ? "orange" : '#006ad1', color: 'white', padding: '2px 5px', borderRadius: '5px' }}>
                  {
                    (isGovtDept) ?
                      'Govt. Department' :
                      (isPDisc) ? "P-Disc / RCO" :
                        "General Installments"
                  }
                </span>
              </div>
            </Typography>
            <CustomerInformationCard
              searchBy={searchBy}
              SearchBy={SearchBy}
              errors={errors}
              values={values}
              touched={touched}
              handleChange={handleChange}
              handleBlur={handleBlur}
              defaultCircle={defaultCircle}
              circleList={circleList}
              setDefaultCircle={setDefaultCircle}
              defaultDivision={defaultDivision}
              divisionList={divisionList}
              setDefaultDivision={setDefaultDivision}
              subDivision={subDivision}
              subDivisionList={subDivisionList}
              setSubDivision={setSubDivision}
              showSubmitErrors={submitCount > 0}
            />
            <Typography variant="h6" className="groupTitle">
              <div className="cyanCell">
              </div>
              Installment Detail
            </Typography>
            <Grid container className='container'>
              <Grid item xs={0.75} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>Bill Month</Typography>
                <TextField name="iv_bill_month"
                  required
                  type='text'
                  onBlur={handleBlur}
                  value={values.iv_bill_month ? formatBillMonth(values.iv_bill_month) : ''}
                  disabled
                  className='textInputField1' />
                <Box className='from-Error'>
                  {errors.iv_bill_month && touched.iv_bill_month ? (errors.iv_bill_month) : null}
                </Box>
              </Grid>
              <Grid item xs={1} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>Due Date</Typography>
                <TextField name='iv_current_bill_due_date'
                  required
                  type='date'
                  onBlur={handleBlur}
                  value={values.iv_current_bill_due_date.slice(0, 10)}
                  disabled
                  className='textInputField1' />
                <Box className='from-Error'>
                  {errors.iv_current_bill_due_date && touched.iv_current_bill_due_date ? (errors.iv_current_bill_due_date) : null}
                </Box>
              </Grid>
              {
                (values.iv_arrears != '' && values.iv_arrears != '0' && values.iv_arrears != undefined)

                  ?
                  <>

                    <Grid item xs={0.75} sx={{ paddingRight: '20px' }}>
                      <Typography className='fieldLabel'>Arrears</Typography>
                      <TextField name="iv_arrears"
                        required
                        type='text'
                        onBlur={handleBlur}
                        value={values.iv_arrears ? values.iv_arrears : ''}
                        disabled
                        className='textInputField1' />
                      <Box className='from-Error'>
                        {errors.iv_arrears && touched.iv_arrears ? (errors.iv_arrears) : null}
                      </Box>
                    </Grid>

                  </>
                  :
                  <></>
              }

              {
                (values.iv_current_bill != '' && values.iv_current_bill != '0' && values.iv_current_bill != undefined)
                  ?
                  <>
                    <Grid item xs={1} sx={{ paddingRight: '20px' }}>
                      <Typography className='fieldLabel'>Bill Amount</Typography>
                      <TextField name="iv_current_bill"
                        required
                        type='text'
                        onBlur={handleBlur}
                        value={values.iv_current_bill}
                        disabled
                        className='textInputField1' />
                      <Box className='from-Error'>
                        {errors.iv_current_bill && touched.iv_current_bill ? (errors.iv_current_bill) : null}
                      </Box>
                    </Grid>


                  </>
                  :
                  <></>
              }
              {
                (values.iv_bill_adj != '' && values.iv_bill_adj != '0' && values.iv_bill_adj != undefined)
                  ?
                  <>
                    <Grid item xs={0.75} sx={{ paddingRight: '20px' }}>
                      <Typography className='fieldLabel'>Bill Adj.</Typography>
                      <TextField name="iv_bill_adj"
                        required
                        type='text'
                        onBlur={handleBlur}
                        value={values.iv_bill_adj ? values.iv_bill_adj : ''}
                        disabled
                        className='textInputField1' />
                      <Box className='from-Error'>
                        {errors.iv_bill_adj && touched.iv_bill_adj ? (errors.iv_bill_adj) : null}
                      </Box>
                    </Grid>
                  </>
                  :
                  <></>
              }

              {
                (values.iv_prev_installment != '' && values.iv_prev_installment != '0' && values.iv_prev_installment != undefined)
                  ?
                  <>
                    <Grid item xs={0.75} sx={{ paddingRight: '20px' }}>
                      <Typography className='fieldLabel'>Inst.</Typography>
                      <TextField name="iv_prev_installment"
                        required
                        type='text'
                        onBlur={handleBlur}
                        value={values.iv_prev_installment ? values.iv_prev_installment : ''}
                        disabled
                        className='textInputField1' />
                      <Box className='from-Error'>
                        {errors.iv_prev_installment && touched.iv_prev_installment ? (errors.iv_prev_installment) : null}
                      </Box>
                    </Grid>
                  </>
                  :
                  <>  </>
              }



              {
                (values.iv_total_fpa != '' && values.iv_total_fpa != '0' && values.iv_total_fpa != undefined)
                  ?
                  <>

                    <Grid item xs={1.2} sx={{ paddingRight: '20px' }}>
                      <Typography className='fieldLabel'>FPA.</Typography>
                      <TextField name="iv_total_fpa"
                        required
                        type='text'
                        onBlur={handleBlur}
                        value={values.iv_total_fpa ? values.iv_total_fpa : ''}
                        disabled
                        className='textInputField1' />
                      <Box className='from-Error'>
                        {errors.iv_total_fpa && touched.iv_total_fpa ? (errors.iv_total_fpa) : null}
                      </Box>
                    </Grid>
                  </>
                  :
                  <>  </>
              }

              {
                (values.iv_outstanding != '' && values.iv_outstanding != '0' && values.iv_outstanding != undefined)
                  ?
                  <>


                    <Grid item xs={1.2} sx={{ paddingRight: '20px' }}>
                      <Typography className='fieldLabel'>Outstanding Amount</Typography>
                      <TextField name="iv_outstanding"
                        required
                        type='text'
                        onBlur={handleBlur}
                        value={values.iv_outstanding ? values.iv_outstanding : ''}
                        disabled
                        className='textInputField1' />
                      <Box className='from-Error'>
                        {errors.iv_outstanding && touched.iv_outstanding ? (errors.iv_outstanding) : null}
                      </Box>
                    </Grid>
                  </>
                  :
                  <>  </>
              }

              <Grid item xs={1} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>Total</Typography>
                <TextField name="iv_total_amount"
                  required
                  type='text'
                  onBlur={handleBlur}
                  value={values.iv_total_amount}
                  disabled
                  className='textInputField1' />
                <Box className='from-Error'>
                  {errors.iv_total_amount && touched.iv_total_amount ? (errors.iv_total_amount) : null}
                </Box>
              </Grid>

              {
                (isDueDatePassed && values.iv_lps != '' && values.iv_lps != '0' && values.iv_lps != undefined)
                  ?
                  <>

                    <Grid item xs={1} sx={{ paddingRight: '20px' }}>
                      <Typography className='fieldLabel'>LPS.</Typography>
                      <TextField name="iv_lps"
                        required
                        type='text'
                        onBlur={handleBlur}
                        value={numberFormatting(calculateLpsForApi(values.iv_lps, currentDateTime, values.iv_current_bill_due_date))}
                        disabled
                        className='textInputField1' />
                      <Box className='from-Error'>
                        {errors.iv_lps && touched.iv_lps ? (errors.iv_lps) : null}
                      </Box>
                    </Grid>
                  </>
                  :
                  <>  </>
              }

              {
                isDetectionBill &&
                <>

                  <Grid item xs={1.2} sx={{ paddingRight: '20px' }}>
                    <Typography className='fieldLabel'>Det Bill Month</Typography>
                    <TextField name="iv_det_month"
                      required
                      type='text'
                      onBlur={handleBlur}
                      value={values.iv_det_month ? values.iv_det_month : ''}
                      disabled
                      className='textInputField1' />
                    <Box className='from-Error'>
                      {errors.iv_det_month && touched.iv_det_month ? (errors.iv_det_month) : null}
                    </Box>
                  </Grid>
                  <Grid item xs={1.2} sx={{ paddingRight: '20px' }}>
                    <Typography className='fieldLabel'>Det Amount</Typography>
                    <TextField name="iv_det_amount"
                      required
                      type='text'
                      onBlur={handleBlur}
                      value={values.iv_det_amount ? values.iv_det_amount : ''}
                      disabled
                      className='textInputField1' />
                    <Box className='from-Error'>
                      {errors.iv_det_amount && touched.iv_det_amount ? (errors.iv_det_amount) : null}
                    </Box>
                  </Grid>
                </>
              }
              <Grid item xs={1} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>Net Total</Typography>
                <TextField name="iv_grand_total"
                  required
                  type='text'
                  onBlur={handleBlur}
                  value={values.iv_grand_total}
                  disabled
                  className='textInputField1' />
                <Box className='from-Error'>
                  {errors.iv_grand_total && touched.iv_grand_total ? (errors.iv_grand_total) : null}
                </Box>
              </Grid>
              <Grid item xs={0.75} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>No. of Inst.</Typography>
                <Select
                  autoWidth={false}
                  disabled={isGovtDept}
                  value={values.iv_no_of_months}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  displayEmpty={true}
                  className='dropdownList'
                  name="iv_no_of_months"
                  id="iv_no_of_months"
                >
                  <MenuItem value=''>Select</MenuItem>

                  {(() => {
                    let maxInstallments = 0;

                    if (CheckPermissions(permissions, 'Billing and Collection', 'Installments', 'Workflow Permissions', '3 Installment')) {
                      maxInstallments = 2;
                    } else if (CheckPermissions(permissions, 'Billing and Collection', 'Installments', 'Workflow Permissions', '4 Installment')) {
                      maxInstallments = 3;
                    } else if (CheckPermissions(permissions, 'Billing and Collection', 'Installments', 'Workflow Permissions', '5 Installment')) {
                      maxInstallments = 4;
                    } else if (CheckPermissions(permissions, 'Billing and Collection', 'Installments', 'Workflow Permissions', '12 Installment')) {
                      maxInstallments = 11;
                    } else if (CheckPermissions(permissions, 'Billing and Collection', 'Installments', 'Workflow Permissions', '40 Installment')) {
                      maxInstallments = 39;
                    }

                    return [...Array(maxInstallments)].map((_, i) => (
                      <MenuItem key={i + 1} value={i + 1}>
                        {i + 1}
                      </MenuItem>
                    ));
                  })()}
                </Select>

                <Box className='from-Error'>
                  {errors.iv_no_of_months && touched.iv_no_of_months ? (errors.iv_no_of_months) : null}
                </Box>
              </Grid>


              {/* {
                (() => {
                  const inputFields = [];
                  for (let i = 0; i < values.iv_no_of_months + 1; i++) {
                    inputFields.push(
                      <Grid item lg={0.75} sx={{ marginLeft: '10px', }} key={i}>
                        <Typography className='fieldLabel' >{i == 0 ? 'Down Payment' : `Inst. ${i}`}</Typography>
                        <div style={{ display: 'flex' }}>
                          <input
                            disabled={i !== 0}
                            name={i === 0 ? 'iv_down_payment' : `installment_${i}`}
                            value={installmentsArray[i]}
                            type="number"
                            id={i === 0 ? 'iv_down_payment' : ''}
                            style={{
                              width: '100%',
                              backgroundColor: i === 0 ? '#006ad1' : 'white', 
                              color: i === 0 ? 'white' : 'black', 
                              height: 'auto',
                              borderRadius: '5px',
                              height: '30px',
                              border: '1px solid lightgrey',
                              padding: '0px 5px'
                            }}
                            inputProps={{
                              max: i == 0 ? (parseInt(values.iv_grand_total?.replace(/,/g, '')) || 0) : undefined, 
                              min: 0
                            }}
                            onChange={(e) => handleInputChange(e, i)}
                          />
                         
                        </div>
                      </Grid>
                    );
                  }
                  return inputFields;
                })()
              } */}

              {
                (() => {
                  const inputFields = [];

                  // Always include the Down Payment field
                  inputFields.push(
                    <Grid item lg={0.75} sx={{ marginLeft: '10px' }} key={0}>
                      <Typography className="fieldLabel">Down Payment</Typography>
                      <div style={{ display: 'flex' }}>
                        <input
                          disabled={false}
                          name="iv_down_payment"
                          value={installmentsArray[0] || ''} // Ensure empty if undefined
                          type="number"
                          id="iv_down_payment"
                          style={{
                            width: '100%',
                            backgroundColor: '#006ad1',
                            color: 'white',
                            height: '30px',
                            borderRadius: '5px',
                            border: '1px solid lightgrey',
                            padding: '0px 5px',
                          }}
                          inputProps={{
                            max: parseInt(values.iv_grand_total?.replace(/,/g, '')) || 0, // Cap at grand total
                            min: 0,
                          }}
                          onChange={(e) => handleInputChange(e, 0)}
                        />
                      </div>
                    </Grid>
                  );

                  // Only add installment fields if iv_no_of_months > 0
                  if (values.iv_no_of_months > 0) {
                    for (let i = 1; i <= values.iv_no_of_months; i++) {
                      inputFields.push(
                        <Grid item lg={0.75} sx={{ marginLeft: '10px' }} key={i}>
                          <Typography className="fieldLabel">{`Inst. ${i}`}</Typography>
                          <div style={{ display: 'flex' }}>
                            <input
                              disabled={true}
                              name={`installment_${i}`}
                              value={installmentsArray[i] || ''} // Ensure empty if undefined
                              type="number"
                              style={{
                                width: '100%',
                                backgroundColor: 'white',
                                color: 'black',
                                height: '30px',
                                borderRadius: '5px',
                                border: '1px solid lightgrey',
                                padding: '0px 5px',
                              }}
                              inputProps={{
                                min: 0,
                              }}
                              onChange={(e) => handleInputChange(e, i)}
                            />
                          </div>
                        </Grid>
                      );
                    }
                  }

                  return inputFields;
                })()
              }
              {
                errors.iv_down_payment &&
                <Grid item lg={12} sx={{ display: 'flex' }}>
                  <p style={{ color: 'red', fontSize: 'small', marginLeft: '1025px' }}>
                    {errors.iv_down_payment ? (errors.iv_down_payment) : null}
                  </p>
                </Grid>
              }
              {
                values.iv_no_of_months ?
                  <Grid item lg={12} sx={{ display: 'flex' }}>
                    <p style={{ color: 'red', fontSize: 'small', marginLeft: '1025px' }}>
                      ** This does not includes applicable financial charges **
                    </p>
                  </Grid> : ''
              }
            </Grid>
            {/* <Typography variant="h6" className="groupTitleDocuments">
              Required Documents
            </Typography>
            <Grid container className='document-container' >
              <Grid item lg={12}>
                <Grid container spacing={1} className='documentsContainer' sx={{ padding: '0px 30px' }}>
                  <Grid item lg={2} >
                    <Typography className='documentLabel' >1- Applicant's CNIC. (Optional)</Typography>
                    <Box className='documentError'>{errors.iv_applicant_cnic_document && touched.iv_applicant_cnic_document ? (errors.iv_applicant_cnic_document) : null} {applicantCnicDocumentError && applicantCnicDocumentError}</Box>
                  </Grid>
                  <Grid item lg={2}>
                    {
                      applicantCnicDocument ?
                        <>
                          <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setApplicantCnicDocument('') }} />}  >
                            {applicantCnicDocumentThumbnail && <img src={applicantCnicDocumentThumbnail} alt="Applicant CNIC" width="100" />}
                          </Button>
                        </>
                        :
                        <>
                          <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                            Upload
                            <input hidden accept={documentExtensions} id='iv_applicant_cnic_document' name='iv_applicant_cnic_document' type="file" onChange={ApplicantCnicDocument} />
                          </Button>
                        </>
                    }
                  </Grid>
                </Grid>
              </Grid>
            </Grid> */}
            <Grid container >
              <Grid item lg={12} sx={{ margin: '0px 50px 0px 25px' }}>
                {
                  error &&
                  <Error
                    error={error}
                    onClose={() => errorCloses()}
                    backgroundColor="#FFC0CB"
                    textColor="#bb0303"
                    iconColor="#bb0303"
                  />
                }
              </Grid>
            </Grid>
            <Box sx={{ marginTop: "1%", textAlign: "right", marginRight: '2%', marginBottom: '2%' }}>
              <Button className={((values.iv_consumer_id.length != 10 || values.iv_reference_number.length != 14)
                // && values.iv_applicant_phone_no != ''
                && values.iv_no_of_months != '' && error == '' && !installmentsAlreadyCheck) === false ? 'disabled-button' : 'button'}
                variant="contained" component="label" type='submit' onClick={handleSubmit} disabled={(((values.iv_consumer_id.length != 10 || values.iv_reference_number.length != 14))
                  // && values.iv_applicant_phone_no != ''
                  && values.iv_no_of_months != '' && error == '') === false}>
                Submit
              </Button>
            </Box>
          </form >
        </Box >
      </Grid >

      < Dialog
        open={installmentsPopUp}
        onClose={handleClose}
        className='dialog'
        fullWidth={true}
        maxWidth={'sm'}
        PaperProps={{ style: { width: '100%', borderRadius: 20 } }}
      >
        <DialogTitle  >
          <Box className="backgroundAttached" >
            <DoneIcon className="icon" />
          </Box>
          <Typography variant="h6" className="groupTitle"> Request Submitted</Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <p className="applicationSubmit">  Your Installments request is submitted successfully.</p>
            <p className="trackIdPara"> Your Tracking ID.</p>
            <p className="trackId"> {applicationId}</p>
          </DialogContentText>
        </DialogContent>
      </Dialog >

      {/* Backdrop */}
      < Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop >

    </>
  );
}

export default InstallmentsForm;